/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Customily looks for the legacy theme.Currency.formatMoney API. Broadcast
  // exposes the same formatter at theme.formatMoney, so provide a compatibility
  // alias instead of letting Customily fall back to its generic dollar formatter.
  if (window.theme && typeof window.theme.formatMoney === 'function') {
    window.theme.Currency = window.theme.Currency || {};
    window.theme.Currency.formatMoney = window.theme.Currency.formatMoney || window.theme.formatMoney;
  }

 (function () {
   // DISABLED: Let SC Product Options handle its own positioning
   // The moving of bold_options was causing conflicts with SC Product Options initialization
   
   // If you need to move the bold_options div, do it AFTER SC Product Options has fully loaded
   // Uncomment and test carefully:
   /*
   function waitForBoldOptions() {
     if (typeof window.BOLD !== 'undefined' && 
         typeof window.BOLD.options !== 'undefined' &&
         typeof window.BOLD.options.loaded !== 'undefined') {
       
       setTimeout(function() {
         var boldOptionsDiv = document.querySelector('.bold_options');
         if (boldOptionsDiv && boldOptionsDiv.children.length > 0) {
           if (typeof $ !== 'undefined') {
             $(".product__controls-group-quantity").insertAfter($("#customily-options"));
             $(".bold_options").insertBefore($(".product__block--buttons"));
           }
         }
       }, 1000);
     } else {
       setTimeout(waitForBoldOptions, 200);
     }
   }
   waitForBoldOptions();
   */
 })();




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
